import { Component } from "react";
import classNames from "classnames";

import CategoryIcon from "./CategoryIcon";

interface ICategoryMapMarkerProps {
  title?: string;
  category?: any;
  lat?: string | number;
  lng?: string | number;
  $hover?: boolean;
}

export default class CategoryMapMarker extends Component<ICategoryMapMarkerProps> {
  static defaultProps = {
    $hover: false,
  };

  render() {
    const { title, category, $hover } = this.props;

    if (category === undefined || category === null) {
      return null;
    }

    const balloonClassNames = classNames({
      "sb-map-balloon": true,
      active: $hover,
    });
    return (
      <div
        className="sb-block-icon"
        style={{
          background:
            category.category_bg_color === "transparent"
              ? "transparent"
              : "#" + category.category_bg_color,
        }}
      >
        <span>
          <CategoryIcon category={category} />
        </span>
        <div className={balloonClassNames}>{title}</div>
      </div>
    );
  }
}
